import { createContext, useContext, useEffect } from 'react';

/**
 * Lets an admin page tell the layout it has unsaved edits, so the sidebar can
 * ask before navigating away (BrowserRouter has no navigation blocker).
 */
export interface UnsavedChanges {
  setUnsaved: (dirty: boolean) => void;
}

export const UnsavedChangesContext = createContext<UnsavedChanges>({
  setUnsaved: () => undefined,
});

/** While `dirty` is true, the admin sidebar asks before leaving the page. */
export const useWarnIfUnsaved = (dirty: boolean): void => {
  const { setUnsaved } = useContext(UnsavedChangesContext);
  useEffect(() => {
    setUnsaved(dirty);
    return () => setUnsaved(false);
  }, [dirty, setUnsaved]);
};
